// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Cartilazen = {
  productCode: "SBOVZ-CQ",
  productName: "Cartilazen CQ",
  ingredients: "Cissus quadrangularis, Boswellia serrata, Rose hip, Parmelia perlata ",
  overview:"Botanical and whole food Vitamin Supplement for Joint Health",
  assay:"Vitamin C: 30 mg; Vitamin D3: 7.5 mcg; Vitamin K2: 25 mcg; B12-Corrinoids: 1.1 mcg; Vitamin B9: 110 mcg; Calcium: 150 g; Selenium: 20 mcg; Zinc: 6.6 mg; Cissus quadrangularis extract: 150 gm; Boswellia serrata extract: 100 mg; Rose Hips extract: 50 mg; Parmelia perlata extract: 4.5 mg",
  coNutrients:"Nutrients from Boswellia will help improve mobility, flexibility and cartilage regeneration by reducing inflammation.",
  studies:"",
  benefits:"Cartilazen helps to fight inflammation, reduces joint pain, promotes collagen production, supports Vitamin-D deficiency, strengthens bones and boosts the immune system. Adding Cartilazen to your balanced diet may help ease the symptoms of your arthritis.",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForConditions/Cartilazen.png"
    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",

  ]
};

export default Cartilazen;
